function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrazilFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#009b37",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 336.55914307,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4679",
    cx: 98.097542,
    cy: 107.28635,
    r: 69.198166
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f3d603",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 293.16552734,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect4681",
    width: 67.405678,
    height: 67.405678,
    x: -74.096138,
    y: 123.50531,
    transform: "matrix(0.83976945,-0.54294316,0.83976945,0.54294316,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#012775",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 301.61221313,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4675",
    cx: 98.097542,
    cy: 107.28635,
    rx: 24.097765,
    ry: 24.539925
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilFlag);
export default __webpack_public_path__ + "static/media/brazil_flag.92730efae8ed02017fec3924ccf4fcf2.svg";
export { ForwardRef as ReactComponent };